import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, GetCredentials } from './types';

export const INITIAL_STATE: GetCredentials = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GetCredentials {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GET_CREDENTIALS_REQUEST: {
				break;
			}

			case Types.GET_CREDENTIALS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.GET_CREDENTIALS_FAILURE: {
				draft.status = 400;
				draft.data = null;
				break;
			}

			case Types.GET_CREDENTIALS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
